export default {
  header: "About Me",
  view: "aboutMe",
  paragraph:
    "This is an additional paragraph that is populated using the paragraph property in the aboutMe store file.",
};
